import { Modal, Stack, Form, Button } from "react-bootstrap";
import añadirOtros from "../functions/añadirOtros";

function ModalAñadir({
  isModalAñadir,
  setIsModalAñadir,
  actualizarEstadoProductos,
  usuario,
}) {
  function añadirOtrosModal() {
    //obtener infor del formulario
    const ruc = usuario.ruc;
    const activo = true;
    const codigo = document.getElementById("codigo").value.trim();
    const nombre = document.getElementById("nombre").value.trim().toUpperCase();
    const descripcion = document.getElementById("descripcion").value.trim().toUpperCase();
    const rev = document.getElementById("rev").value.trim().toUpperCase();
    const orden = document.getElementById("orden").value.trim();
    const url = document.getElementById("url").value.trim().toLowerCase();
    const baseDatos = `reglamentos`;
    // enviar informacion a firebase
    const infoProducto = {activo, codigo, nombre, descripcion, rev, orden, url, ruc};
    añadirOtros(infoProducto, usuario.email, baseDatos);
    // cerrar modal
    actualizarEstadoProductos(baseDatos);
    setIsModalAñadir(false);
  }

  return (
    <Modal show={isModalAñadir} onHide={() => setIsModalAñadir(false)}>
      <Modal.Header>
        <Modal.Title>Añadir Formulario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
        <Stack>
          <Form.Control
              id="codigo"
              placeholder="Código"
              type="text"
              classdescripcion="mb-1"
            />
            <Form.Control
              id="nombre"
              placeholder="Nombre"
              type="text"
              classdescripcion="mb-1"
            />
            <Form.Control
              id="descripcion"
              placeholder="Descripción"
              type="text"
              classdescripcion="mb-1"
            />
            <Form.Control
              id="rev"
              placeholder="Revisión"
              type="text"
              classdescripcion="mb-1"
            />
            <Form.Control
              id="orden"
              placeholder="Orden"
              type="number"
              classdescripcion="mb-1"
            />
            <Form.Control
              id="url"
              placeholder="URL"
              type="text"
              classdescripcion="mb-1"
            />
          </Stack>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setIsModalAñadir(false)}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={añadirOtrosModal}>
          Añadir
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAñadir;
